
import { Vue, Component, Watch, Ref } from 'vue-property-decorator';
import EchartsComponent from '../subassembly/echartsComponent.vue';
import EchartsNextComponent from '../subassembly/echartsNextComponent.vue';
import { City } from '@/common/interface/shop';
import lazyInject from '@/di';
import ShopService from '@/services/shop.service';
import EchartsModal from '../subassembly/echartsModal.vue';
import { warkLabel } from '@/models/wark';


enum tagsList {
  列表 = 1,
  图表1 = 2,
  图表2 = 3,
  排名 = 4,
}
@Component({
  components: {
    EchartsComponent,
    EchartsNextComponent,
    EchartsModal,
  },
})

export default class AdvertiserFollowUp extends Vue {
  title = '广告主跟进数据';

  @Ref('echartsComponent')
  echartsComponent!: EchartsComponent;

  @Ref('echartsNextComponent')
  echartsNextComponent!: EchartsNextComponent;

  @Ref('echartsModal')
  echartsModal!: EchartsModal;

  @lazyInject(ShopService)
  shopService!: ShopService;

  currentMonthData = [];

  typeChild = '';

  citys: City[] = [];

  listData = [{
    department: '部门',
    group: '组',
    leader: '负责人',
    leaderID: '负责人ID',
    action: '操作',
  }];

  formData: any = {
    department: '',
    group: '',
    leader: '',
    leaderID: '',
    action: '',
    city: '',
    category: '',
    mainBusiness: '',
    shopName: '',
    poi: '',
    rechargeTime: '',
  };

  listColumns = warkLabel.init('AdvertiserFollowUp');

  pagination = {
    pageSize: 10,
    current: 1,
    onChange: this.onChangePage,
  };

  TagsList = tagsList;

  listForm = {
    type: tagsList.列表,
  };

  chart1Form = {
    type: tagsList.图表1,
    city: '',
    time: '',
    regionId: '',
  };

  chart2Form = {
    type: tagsList.图表2,
  };

  rankForm = {
    type: tagsList.排名,
  };

  lastMonthData = [];

  columns = [];

  rankingColumns = [
    {
      title: '排名',
      dataIndex: 'rank',
      align: 'center',
    },
    {
      title: '部门',
      dataIndex: 'department',
      align: 'center',
    },
    {
      title: '应充门店数量',
      dataIndex: 'shouldChargeShopCount',
      align: 'center',
    },
    {
      title: '店均沟通次数',
      dataIndex: 'shopAverageCommunicationCount',
      align: 'center',
    },
    {
      title: '实充门店数量',
      dataIndex: 'actualChargeShopCount',
      align: 'center',
    },
    {
      title: '实充率',
      dataIndex: 'actualChargeRate',
      align: 'center',
    },
    {
      title: '操作',
      dataIndex: 'action',
      scopedSlots: { customRender: 'action' },
      align: 'center',
    },
  ];

  rankingData = [{ id: 433 }];

  mode = tagsList.列表;

  modeList: tagsList[] = [
    tagsList.列表,
    tagsList.图表1,
    tagsList.图表2,
    tagsList.排名,
  ];

  @Watch('$route')
  onRouteChange() {
    const { type } = this.$route.query;
    this.mode = Number(type) || tagsList.列表;
    if (type == '2') {
      this.$nextTick(() => {
        this.echartsComponent.getChart1Data();
      });
    } else if (type == '3') {
      this.$nextTick(() => {
        this.echartsNextComponent.getChart1Data();
      });
    }
  }
  refresh() {
  }

  setQuery() {
    const { current, pageSize } = this.pagination;
    const type = this.mode;
    let query: any = {
      page: current || 1,
      pageSize: pageSize || 10,
      type: this.mode,
    };
    if (type === tagsList.列表) {
      const { department, group, leader, leaderID, action, city, category, mainBusiness, shopName, poi, rechargeTime } = this.formData;
      query = {
        department,
        group,
        leader,
        leaderID,
        action,
        city,
        category,
        mainBusiness,
        shopName,
        poi,
        rechargeTime,
      };
    } else if (type === tagsList.图表1) {
      const { city, time, regionId } = this.chart1Form;
      query = {
        city,
        time,
        regionId,
      };
    }
    query.timestamp = Math.round(Date.now() / 1000);

    return query;
  }

  onChangePage(page: number, pageSize: number) {
    this.pagination.current = page;
    this.pagination.pageSize = pageSize;
    // this.setQuery();
    this.$router.push({
      query: this.getQuery(),
    });
  }

  back() {
    this.$router.push({
      name: 'workbenches.index',
    });
  }
  handrecord: any = {};
  handleAction(record: any) {
    this.echartsModal.getChart1Data();
    this.handrecord = record;
  }
  onChangePicker() {
    // console.log(value, 'value');
  }
  mounted() {
    this.onRouteChange();
    this.getCityList();
    this.typeChild = localStorage.getItem('typeChild') || '';
  }

  search() {
    this.pagination.current = 1;
    this.pagination.pageSize = 10;
    const query = this.getQuery();
    query.timestamp = Math.round(Date.now() / 1000);
    this.$router.push({
      query,
    });
  }

  getQuery() {
    const query: any = {};
    if (this.mode === tagsList.列表) {
      query.type = this.listForm.type;
    } else if (this.mode === tagsList.图表1) {
      query.type = this.chart1Form.type;
      query.city = this.chart1Form.city;
      query.time = this.chart1Form.time;
      query.regionId = this.chart1Form.regionId;
    } else if (this.mode === tagsList.图表2) {
      query.type = this.chart2Form.type;
    } else if (this.mode === tagsList.排名) {
      query.type = this.rankForm.type;
    }
    return query;
  }

  resetQuery() {
    this.pagination.current = 1;
    this.pagination.pageSize = 10;
    const query: any = {
      page: 1,
      pageSize: 10,
      type: this.mode,
    };
    query.timestamp = Math.round(Date.now() / 1000);
    this.$router.push({
      query,
    });
  }

  handleModeChange(key: tagsList) {
    const query: any = {
      ...this.getQuery(),
    };
    if (key === tagsList.列表) {
      query.type = this.listForm.type;
    } else if (key === tagsList.图表1) {
      query.type = this.chart1Form.type;
    } else if (key === tagsList.图表2) {
      query.type = this.chart2Form.type;
    } else if (key === tagsList.排名) {
      query.type = this.rankForm.type;
    }

    this.$router.push({
      query,
    });
  }

  async getCityList() {
    const response = (await this.shopService.getCityList()) as unknown as {
      [key: string]: {
        province: City;
        city: City[];
      };
    };
    if (response) {
      const citys = Object.values(response)
        .map((item) => item.city)
        .reduce((prev, cur) => prev.concat(cur), []);
      this.citys = citys;
    } else {
      this.citys = [];
    }
  }

  /** 省市过滤 */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  regionFilterOption(input: string, option: any) {
    return (
      option.componentOptions.children[0].text
        .toLowerCase()
        .indexOf(input.toLowerCase()) >= 0
    );
  }
}
